import { render, staticRenderFns } from "./AuthRegisterConfirm.vue?vue&type=template&id=61c2ff2e&scoped=true&"
import script from "./AuthRegisterConfirm.vue?vue&type=script&lang=js&"
export * from "./AuthRegisterConfirm.vue?vue&type=script&lang=js&"
import style0 from "./AuthRegisterConfirm.vue?vue&type=style&index=0&id=61c2ff2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c2ff2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardSubtitle,VCardText,VCardTitle,VCol,VRow})
